// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "price-2A8Pr";
var _4 = "total-14q4p";
var _5 = "totalTitle-bRzqy";
var _6 = "money-11KkH";
var _7 = "row-1D5Jh";
export { _1 as "__esModule", _2 as "mobile", _3 as "price", _4 as "total", _5 as "totalTitle", _6 as "money", _7 as "row" }
export default { "__esModule": _1, "mobile": _2, "price": _3, "total": _4, "totalTitle": _5, "money": _6, "row": _7 }
